// src/pages/EmailNotification.js
import React, { useState, useEffect, useContext } from "react";
import {
  TextField,
  Button,
  Switch,
  FormControlLabel,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { request } from "../utils/request";
import { ColorModeContext } from "../index";  // ← import your theme context

const EmailNotification = () => {
  // consume light/dark mode
  const { mode } = useContext(ColorModeContext);

  // Local state for the configuration form
  const [isEnabled, setIsEnabled] = useState(false);
  const [formData, setFormData] = useState({
    smtpServer: "",
    smtpPort: "",
    smtpHelloDomain: "",
    smtpUsername: "",
    smtpPassword: "",
    emailRecipients: [""],
  });
  const [configId, setConfigId]         = useState(null);
  const [message, setMessage]           = useState("");
  const [loadedConfig, setLoadedConfig] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const data = await request("/email-notifications", { method: "GET" });
        if (data.success && data.emailNotification) {
          const cfg = data.emailNotification;
          setLoadedConfig(cfg);
          setConfigId(cfg._id);
          setIsEnabled(cfg.isEnabled);
          setFormData(
            cfg.isEnabled
              ? {
                  smtpServer: cfg.smtpServer,
                  smtpPort: cfg.smtpPort,
                  smtpHelloDomain: cfg.smtpHelloDomain,
                  smtpUsername: cfg.smtpUsername,
                  smtpPassword: cfg.smtpPassword,
                  emailRecipients:
                    cfg.emailRecipients.length > 0 ? cfg.emailRecipients : [""],
                }
              : {
                  smtpServer: "",
                  smtpPort: "",
                  smtpHelloDomain: "",
                  smtpUsername: "",
                  smtpPassword: "",
                  emailRecipients: [""],
                }
          );
        }
      } catch (err) {
        console.error("Error fetching config:", err);
      }
    };
    fetchConfig();
  }, []);

  const handleSwitchChange = (e) => {
    setIsEnabled(e.target.checked);
    if (!e.target.checked) {
      setFormData({
        smtpServer: "",
        smtpPort: "",
        smtpHelloDomain: "",
        smtpUsername: "",
        smtpPassword: "",
        emailRecipients: [],
      });
    }
  };

  const handleChange = (e, index = null) => {
    if (index !== null) {
      const newEmails = [...formData.emailRecipients];
      newEmails[index] = e.target.value;
      setFormData({ ...formData, emailRecipients: newEmails });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };

  const addEmailField = () => {
    setFormData({ ...formData, emailRecipients: [...formData.emailRecipients, ""] });
  };

  const handleSubmit = async () => {
    const payload = isEnabled
      ? { ...formData, isEnabled }
      : {
          isEnabled,
          smtpServer: "",
          smtpPort: "",
          smtpHelloDomain: "",
          smtpUsername: "",
          smtpPassword: "",
          emailRecipients: [],
        };
    const method   = configId ? "PUT" : "POST";
    const endpoint = configId
      ? `/email-notifications/${configId}`
      : "/email-notifications";
    try {
      const data = await request(endpoint, { method, body: payload });
      if (data.success) {
        setMessage("Configuration saved successfully!");
        setLoadedConfig(data.emailNotification);
        setConfigId(data.emailNotification._id);
      } else {
        setMessage("Failed to save configuration.");
      }
    } catch (err) {
      console.error("Error saving configuration:", err);
      setMessage("Error saving configuration.");
    }
  };

  // base inline styles
  const containerStyle     = { padding: "20px", fontFamily: "Arial, sans-serif" };
  const tableStyle         = { width: "100%", borderCollapse: "collapse", marginTop: "20px" };
  const thStyle            = { border: "1px solid #ddd", padding: "8px", textAlign: "left" };
  const tdStyle            = { border: "1px solid #ddd", padding: "8px", textAlign: "left" };
  const formContainerStyle = {
    border: "1px solid #ccc",
    padding: "15px",
    borderRadius: "8px",
    marginTop: "20px",
  };

  // override styles for dark mode
  const containerDarkOverride = mode === "dark" ? { color: "#fff" } : {};
  const headerCellDarkStyle   = mode === "dark"
    ? { ...thStyle, backgroundColor: "#2d3448", color: "#fff" }
    : thStyle;
  const rowCellDarkStyle      = mode === "dark"
    ? { ...tdStyle, backgroundColor: "#2d3448", color: "#fff" }
    : tdStyle;
  const headingDarkStyle      = mode === "dark"
    ? { color: "#fff", textAlign: "center" }
    : { textAlign: "center" };

  return (
    <div style={{ ...containerStyle, ...containerDarkOverride }}>
      {/* Main heading */}
      <h2 style={headingDarkStyle}>Email Notification Settings</h2>

      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <FormControlLabel
          control={<Switch checked={isEnabled} onChange={handleSwitchChange} />}
          label="Enable Email Notifications"
        />
      </div>

      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <Button
          variant="contained"
          onClick={handleSubmit}
          style={{
            padding: "10px 20px",
            backgroundColor: "#1976d2",
            color: "white",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Submit
        </Button>
      </div>

      {/* If enabled, display the SMTP configuration form */}
      {isEnabled && (
        <div style={formContainerStyle}>
          {/* <h3 style={{ textAlign: "center" }}>Configure SMTP</h3> */}
          {/* <TextField
            label="SMTP Server"
            name="smtpServer"
            onChange={handleChange}
            value={formData.smtpServer}
            fullWidth
            margin="normal"
          /> */}
          {/* <TextField
            label="SMTP Port"
            name="smtpPort"
            onChange={handleChange}
            value={formData.smtpPort}
            fullWidth
            margin="normal"
          /> */}
          {/* <TextField
            label="SMTP Hello Domain"
            name="smtpHelloDomain"
            onChange={handleChange}
            value={formData.smtpHelloDomain}
            fullWidth
            margin="normal"
          /> */}
          <TextField
            label="SMTP Username"
            name="smtpUsername"
            onChange={handleChange}
            value={formData.smtpUsername}
            fullWidth
            margin="normal"
          />
          {/* <TextField
            label="SMTP Password"
            name="smtpPassword"
            type="password"
            onChange={handleChange}
            value={formData.smtpPassword}
            fullWidth
            margin="normal"
          /> */}
          <Divider style={{ margin: "20px 0" }} />
          {formData.emailRecipients.map((email, index) => (
            <TextField
              key={index}
              label="Email Recipient"
              value={email}
              onChange={(e) => handleChange(e, index)}
              fullWidth
              margin="normal"
              type="email"
              error={
                email &&
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
              }
              helperText={
                email &&
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email)
                  ? "Please enter a valid email address"
                  : ""
              }
            />
          ))}
          <IconButton onClick={addEmailField}>
            <Add />
          </IconButton>
        </div>
      )}

      {message && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "#333" }}>
          {message}
        </p>
      )}

      {/* Display the current configuration in a table */}
      {loadedConfig && (
        <>
          {/* Sub-heading */}
          <h3 style={{ ...headingDarkStyle, marginTop: "30px" }}>
            Current Configuration
          </h3>
          <TableContainer component={Paper}>
            <Table style={tableStyle}>
              <TableHead>
                <TableRow>
                  <TableCell style={headerCellDarkStyle}>SMTP Username</TableCell>
                  <TableCell style={headerCellDarkStyle}>Emails</TableCell>
                  <TableCell style={headerCellDarkStyle}>Enabled</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell style={rowCellDarkStyle}>
                    {loadedConfig.smtpUsername || "-"}
                  </TableCell>
                  <TableCell style={rowCellDarkStyle}>
                    {loadedConfig.emailRecipients &&
                    loadedConfig.emailRecipients.length > 0
                      ? loadedConfig.emailRecipients.join(", ")
                      : "-"}
                  </TableCell>
                  <TableCell style={rowCellDarkStyle}>
                    {loadedConfig.isEnabled ? "Yes" : "No"}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </div>
  );
};

export default EmailNotification;
